import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import {useEvent} from 'Event/EventProvider'
import {useAddObieAttendeeLink} from 'lib/event-api/integrations/obie/attendee-links/add'
import Dialog from 'lib/ui/Dialog'
import AttendeeLinkForm from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks/AttendeeLinkForm'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface AddAttendeeLinkDialogProps {
  showing: boolean
  obieHubId: string
  onClose: () => void
}

export default function AddAttendeeLinkDialog(
  props: AddAttendeeLinkDialogProps,
) {
  const {showing, obieHubId, onClose} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const addLink = useAddObieAttendeeLink({client, event})

  const close = () => {
    addLink.reset()
    onClose()
  }

  return (
    <Dialog open={showing} onClose={close}>
      <DialogTitle>Add attendee link</DialogTitle>
      <DialogContent>
        <AttendeeLinkForm
          obieHubId={obieHubId}
          link={{
            label: '',
            slug: '',
            obie_journey_id: '',
            obie_milestone_id: null,
            obie_step_id: null,
          }}
          isSaving={addLink.isLoading}
          error={addLink.error}
          submitLabel="Save link"
          onSubmit={(data) => addLink.mutate(data, {onSuccess: close})}
        />
      </DialogContent>
    </Dialog>
  )
}
